import { useState } from 'react';
import { useMutation } from '@apollo/client';
import { InvoiceState } from 'containers/SettlementRequest/graphQL/types';
import { useUserInformation } from 'graphQL/Zustand/useUserInformation';
import { errorHandler } from 'utils/ErrorHandler';
import { GENERATE_INVOICES_FILE } from '..';
import { InvoiceFilterInput } from './useQueryGetInvoiceList';

export function useMutationInvoicesFile() {
  const [generateInvoicesFile] = useMutation(GENERATE_INVOICES_FILE);
  const hostId = useUserInformation(state => state.userInfo.me.host.id);

  const [isFailed, setIsFailed] = useState<boolean>(false);

  const handleCloseFailedDialog = () => {
    setIsFailed(false);
  };

  const handleGenerateInvoicesFile = async (filter: InvoiceFilterInput) => {
    if (filter.term === null) {
      setIsFailed(true);

      return;
    }

    try {
      const response = await generateInvoicesFile({
        variables: {
          filter: {
            ...filter,
            hostId,
            statusIn: [InvoiceState.COMPLETED],
          },
        },
      });

      if (response) {
        if (response.data.generateInvoicesFileForHost.success) {
          window.showToast(
            '지급 완료 정산 건 엑셀 다운로드가 완료되었어요.',
            'success',
          );

          const downloadUrl = response.data.generateInvoicesFileForHost.url;

          window.location.href = downloadUrl; // 직접 다운로드

          return;
        }

        window.showToast(
          response.data.generateInvoicesFileForHost.message,
          'failed',
        );
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  return { isFailed, handleGenerateInvoicesFile, handleCloseFailedDialog };
}
